import { render, staticRenderFns } from "./MediaImageView.vue?vue&type=template&id=3a5bdd3e&scoped=true&"
import script from "./MediaImageView.vue?vue&type=script&lang=ts&"
export * from "./MediaImageView.vue?vue&type=script&lang=ts&"
import style0 from "./MediaImageView.vue?vue&type=style&index=0&id=3a5bdd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5bdd3e",
  null
  
)

export default component.exports